import { render, staticRenderFns } from "./TemplateEditPageSettings.vue?vue&type=template&id=46d4a0bb&scoped=true"
import script from "./TemplateEditPageSettings.vue?vue&type=script&lang=js"
export * from "./TemplateEditPageSettings.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditPageSettings.vue?vue&type=style&index=0&id=46d4a0bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4a0bb",
  null
  
)

export default component.exports